import { lazy } from "react";
import { dashboardFilledSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import( /* webpackChunkName: "dashboard" */ './components/EntryPoint'));

export const defaultPath = '/dashboard';

const innerRoutes = [];

const Dashboard = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: dashboardFilledSVG,
    title: {
        key: 'dashboard',
        plural: false
    },
    subTitle: {
        key: 'dashboard_subtitle',
        plural: false
    },
    innerRoutes,
    pathChilds: innerRoutes.map(route => route.path)
};

export default Dashboard;
